import { render } from "./SourceMenu.vue?vue&type=template&id=0bf15230"
import script from "./SourceMenu.vue?vue&type=script&lang=js"
export * from "./SourceMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__